import { MEMBER_STATUS } from '../constants/copy.js';

/** API statuses are snake_case; the vocabulary (`MEMBER_STATUS`) is camelCase. */
const STATUS_BY_API = Object.freeze({ not_invited: MEMBER_STATUS.NOT_INVITED });

/**
 * API group (snake_case, camelCase tolerated) → UI group. Contract TBD (ARP/backend).
 *
 * @param {object} raw
 */
export const mapApiGroupToUi = (raw) => ({
  id: raw.id,
  name: raw.name,
  description: raw.description ?? '',
  memberCount: raw.member_count ?? raw.memberCount ?? 0,
  membersPreview: raw.members_preview ?? raw.membersPreview ?? [],
});

/**
 * API member of a group → row of the members table. A removed or suspended member keeps its
 * status (the table shows the badge, it never hides them).
 *
 * @param {object} raw
 */
export const mapApiGroupMemberToUi = (raw) => {
  const status = raw.status;

  return {
    id: raw.id,
    name: raw.display_name ?? raw.displayName ?? raw.name ?? raw.email,
    email: raw.email,
    jobTitle: raw.job_title ?? raw.jobTitle ?? null,
    lastActiveAt: raw.last_active_at ?? raw.lastActiveAt ?? null,
    mfaEnabled: raw.mfa_enabled ?? raw.mfaEnabled ?? false,
    status: STATUS_BY_API[status] ?? status,
  };
};
